module.exports = __webpack_public_path__ + "img/25.29c9add6.jpg";